import jsonLogic from 'json-logic-js';

/**
 * Reduces parents values arrays into a single boolean array
 * @param parents boolean[][]
 * @param length values length
 */
const reduceParents = (parents, length) => {
  const reducedParents = [];

  // Getting biggest parents array
  parents.sort((a, b) => b.length - a.length);

  // Getting indexes length
  for (let index = 0; index < length; index += 1) {
    const currentIndexResult = parents.reduce((previousValue, currentValue) => {
      if (currentValue.length === 1) return previousValue && currentValue[0];
      if (currentValue[index] === undefined) return false;
      return previousValue && currentValue[index];
    }, true);

    reducedParents[index] = currentIndexResult;
  }

  return reducedParents;
};

/**
 * Equals
 */
const safeEqual = (value, comparator) => {
  if (!isNaN(comparator)) {
    if (!isNaN(value)) {
      return parseFloat(value) === parseFloat(comparator);
    }
    return false;
  }
  if (!isNaN(value)) {
    return false;
  }
  return value === comparator;
};

/**
 * Reduces values with parents
 * @param values Values array
 * @param parents Parents array
 * @param compareFunction Compare function
 */
const reduceValues = (
values,
parents,
compareFunction
) => {
  // If variable/option has no parents
  if (parents === undefined || parents.length === 0) {
    return values.map(currentValue => {
      return compareFunction(currentValue, true);
    });
  }

  // If variable/option has parents
  const reducedParents = reduceParents(parents, values.length);
  return values.map((currentValue, index) => {
    return compareFunction(currentValue, reducedParents[index]);
  }) ;
};

/**
 * Additionnal operations
 */
/**
 * SELECTED
 * --------
 * Make sure values are true, in case of an array, all array's values
 * must be true too
 */
jsonLogic.add_operation("selected", (value) => {
  if (!Array.isArray(value)) {
    return value === true;
  } else {
    let filter = value.filter(_value => _value === true);
    return value.length === filter.length;
  }
});

/**
 * NOT-SELECTED
 * ------------
 * Make sure values are false, in case of an array, all array's values
 * must be false too
 */
jsonLogic.add_operation("not-selected", (value) => {
  if (!Array.isArray(value)) {
    return value === false;
  } else {
    let filter = value.filter(_value => _value === false);
    return value.length === filter.length;
  }
});

/**
 * HAS-ONE
 * -------
 * Value must be an array of 1 element only
 */
jsonLogic.add_operation("has-one", (value) => {
    if(!Array.isArray(value)){
        return true;
    } else {
        return value.length === 1;
    }
});

/**
 * AT-LEAST-ONE
 * -------
 * Value must be an array with at least one element
 */
jsonLogic.add_operation("at-least-one", (value) => {
    if(!Array.isArray(value)){
        return true;
    } else {
        return value.includes(true);
    }
});

/**
 * HAS-MANY
 * --------
 * Value must be an array of more then 1 element
 */
jsonLogic.add_operation("has-many", (value) => {
    if(!Array.isArray(value)){
        return false;
    } else {
        return value.length > 1;
    }
});

jsonLogic.add_operation("=", (
  values,
  comparator,
  parents
) => {
  // Reducing value with parents
  const reducedValues = reduceValues(values || [], parents, (value, parent) => {
    return safeEqual(value, comparator) && parent;
  });

  const filter = reducedValues.filter(_value => _value === true);
  return reducedValues.length === filter.length;
})

/**
 * CONTAINS
 * --------
 * Warning: The name is misleading
 * Value must be equal to the comparator
 * in case of an array, all of it's values must
 * be equal to the comparator
 */
jsonLogic.add_operation("contains", (value, comparator) => {
  if (!Array.isArray(value)) {
    return value === comparator;
  } else {
    let filter = value.filter(_value => _value === comparator);
    return value.length === filter.length;
  }
});

/**
 * DOES-NOT-CONTAIN
 * ----------------
 * Warning: The name is misleading
 * Value must not be equal to the comparator
 * in case of an array, all of it's values must
 * not be equal to the comparator
 */
jsonLogic.add_operation("does-not-contain", (value, comparator) => {
  if (!Array.isArray(value)) {
    return value !== comparator;
  } else {
    let filter = value.filter(_value => _value !== comparator);
    return value.length === filter.length;
  }
});

export default jsonLogic;


// WEBPACK FOOTER //
// ./src/logic/jsonlogic/wrapper.js